import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';

export interface IPayload {
    name: string;
    email: string;
    phone?: string;
    address?: string;
}

interface IProps {
    customerId: string;
    payload: IPayload;
}

export const useCreateNewRecipientMutation = ({ customerId, payload }: IProps) => useMutation(
  'useCreateNewRecipientMutation',
  async () => {
    const res = await httpService.put(`/api/v1/user/${customerId}/recipient`, { ...payload });
    return res.data;
  },
  { retry: 1 },
);
